module.exports = __webpack_public_path__ + "img/bg_0.3a2c8bfe.jpg";